import React, { useEffect } from "react";
import styles from "./styles.module.css";
import AnimatedNudge from "../AnimatedNudge";
import { getWidth } from "../../../utils/relativeSizes";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { getShowStartGameNudge } from "../store/actions";
import { GAMEPLAY_ANIMATION_IMAGES } from "../../../assets";
import { useTranslation } from "react-i18next";
import { playStartSoundOfGame } from "../../../classes/voiceovers/GameSoundManager";

const _playStartSound = () => {
  playStartSoundOfGame();
};

function StartGameAnimation() {
  const { t } = useTranslation();
  const showStartGameNudge = useSelector(getShowStartGameNudge);

  useEffect(() => {
    if (showStartGameNudge) {
      setTimeout(_playStartSound, 500);
    }
  }, [showStartGameNudge]);

  if (!showStartGameNudge) {
    return null;
  }

  return (
    <AnimatedNudge>
      <div 
        className={clsx(styles.wrapper, "hexagonShapeWrapper")}
        style={{ 
          backgroundImage: `url(${GAMEPLAY_ANIMATION_IMAGES.hexagonShape})`, 
          width: getWidth(110), 
          height: getWidth(72)
        }}
      >
        <img
          src={GAMEPLAY_ANIMATION_IMAGES.lbStartThumbsUp}
          className={clsx(styles.thumbsUp)}
          alt="Thumbs Up"
          height={getWidth(40)}
          width={getWidth(40)}
        />
        <div className={clsx(styles.text, styles.startText, "hexagonShapeText fontSizeSm12 fontWeightBolder textUppercase fontColorDarkBlue2 flex alignItemCenter justifyContentCenter relative")}>{t("start")}</div>
      </div>
    </AnimatedNudge>
  );
}

export default StartGameAnimation;
